/* @flow */
import ActivityActions from 'payments/actions/ActivityActions';
import ActivityStore from 'payments/stores/ActivityStore';
import ChatActions from 'chat/actions/ChatActions';
import ChatStore from 'chat/stores/ChatStore';
import CurrentUser from 'auth/CurrentUser';
import DeviceActions from 'actions/DeviceActions';
import DeviceStore from 'stores/DeviceStore';
import GroupActions from 'groups/actions/GroupActions';
import Groups from 'collections/Groups';
import GroupStore from 'groups/stores/GroupStore';
import LeadActions from 'actions/LeadActions';
import Leads from 'collections/Leads';
import LeadStore from 'stores/LeadStore';
import OrganizationActions from 'actions/OrganizationActions';
import OrganizationStore from 'stores/OrganizationStore';
import SettingsActions from 'actions/SettingsActions';
import SettingsStore from 'stores/SettingsStore';
import UnreadActions from 'actions/UnreadActions';
import UnreadStore from 'stores/UnreadStore';
import User from 'entities/User';
import { rootGroup } from 'entities/RootGroup';

function promiseGroups(): Promise<?Groups> {
  if (GroupStore.isLoaded()) {
    return Promise.resolve();
  } else {
    return GroupActions
      .loadGroups()
      .catch(error => {
        if (error && error.code === 'information_required') {
          console.warn('promiseGroups information_required', error);
        } else {
          console.warn(error, error.stack);
          console.error('promiseGroups failure');
        }
      });
  }
}

function promiseLeads(): Promise<?Leads> {
  if (LeadStore.isLoaded()) {
    return Promise.resolve();
  } else {
    return LeadActions
      .loadLeads()
      // could get a 404 error trying to load in a new account
      .catch(error => console.warn(error));
  }
}

export function promiseSettings(): Promise<void> {
  if (SettingsStore.isLoaded()) {
    return Promise.resolve();
  } else {
    // then to return void
    return SettingsActions.loadSettings().then(() => {});
  }
}

const promiseBlockingData = () => Promise.all([
  promiseGroups(),
  promiseLeads(),
  promiseSettings(),

  OrganizationStore.isLoaded() ? null : OrganizationActions.loadUserOrganizations(),
  DeviceStore.isLoaded() ? null :
    DeviceActions.loadDevices(),
]);

export function promiseAppData (user: User): Promise<void> {
  if (!user.completedSetup()) {
    // most components assume this was already loaded
    return promiseSettings();
  }

  // kick these off async since it's not strictly necessary for boot
  if (ChatStore.getChats(rootGroup).isEmpty()) {
    ChatActions.loadChats(rootGroup);
  }
  if (UnreadStore.getUnreads().isEmpty()) {
    UnreadActions.loadUnreads();
  }
  if (ActivityStore.getActivities().isEmpty()) {
    ActivityActions.load();
  }
  return promiseBlockingData().then(() => {});
}

export function promiseDataIfSignedIn (): Promise<void> {
  if (CurrentUser.isSignedIn()) {
    return promiseAppData(CurrentUser.getUser());
  } else {
    return Promise.resolve();
  }
}



// WEBPACK FOOTER //
// ./src/promises/userBootData.js